<div class="component-bank">
  <div class="row mb-2">
    <div class="col-12" *ngIf="!readOnly">
      <ng-select
        bindLabel="bank"
        bindValue="code"
        attr.name="{{ name }}"
        notFoundText="Nenhum banco encontrado"
        placeholder="Banco"
        attr.data-cy="{{ dataCy }}"
        [(ngModel)]="selectedBankId"
        [readOnly]="readOnly"
      >
        <ng-option *ngFor="let bank of banks" [value]="bank.code">{{
          bank.code + " - " + bank.name
        }}</ng-option>
      </ng-select>
    </div>
    <div class="col-12" *ngIf="readOnly">
      <input
        type="text"
        class="form-control"
        attr.name="{{ name }}"
        [(ngModel)]="selectedBankId"
        disabled="disabled"
      />
    </div>
  </div>
</div>
